import { render, staticRenderFns } from "./VReviewAdd.vue?vue&type=template&id=4ae5179c&scoped=true&"
import script from "./VReviewAdd.vue?vue&type=script&lang=js&"
export * from "./VReviewAdd.vue?vue&type=script&lang=js&"
import style0 from "./VReviewAdd.vue?vue&type=style&index=0&id=4ae5179c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae5179c",
  null
  
)

export default component.exports